/* eslint-disable no-unneeded-ternary */
/* eslint-disable react/jsx-key */
import React, { Component } from 'react'
import { Button, Input, InputNumber, Select, message, Spin, Modal } from 'antd'
import R from 'ramda'
import styled from 'styled-components'
import { postCard99, deleteCard99 } from 'api/pgads'
import InsertHeader from './InsertHeader'
const { TextArea } = Input
export const HeaderDiv = styled.div`
  padding-bottom: 10px;
  padding-top: 10px;
  //background-color: lightgrey;
`
export const HeaderTag = styled.h4`
  margin-left: 10px;
  font-weight: bold;
  color: darkblue;
`
export const SupDiv = styled.div`
  display: flex;
  //border: 1px solid grey;
  padding: 2px;
`
export const ContentDiv = styled.div`
  border: 1px solid #89c6e2;
  padding: 5px;
  margin: 2px;
`
export const SubDiv = styled.div`
  display: inline-grid;
  width: -webkit-fill-available;
`
const fuelCodeOption = R.compose(
  R.map(([key, text]) => ({ key, text, value: key })),
  R.sortBy(([, text]) => text.toLowerCase()),
  R.toPairs
)
const noneFuelCodeOption = { key: '', text: '', value: '' }

class Card99EditPrompt extends Component {
  state = {
    ...this.props,
    ...this.props.rowData,
    // loadChar: this.props.rowData == undefined ? '1' : this.props.rowData.loadChar,
    errors: [],
  }

  onClose = () => this.setState({ msg: undefined })
  closeErrorPrompt = () => this.setState({ errorPrompt: false })

  save = () => {
    const { mode = 'N', targetInfo, card99Extend } = this.props
    const { utility, unit } = this.state
    if (
      utility === undefined ||
      unit === undefined ||
      utility == null ||
      unit == null
    ) {
      message.error('Please, Select Unit')
      return
    }

    if (mode === 'V') {
      this.props.setDataErrors(null)
      this.props.setShowEditDialog(false)
      // this.setState({ loading: false })
      this.props.setLoading(false)

      return
    }

    // this.setState({ loading: true })
    this.props.setLoading(true)
    const data = [
      {
        // utility: mode == 'new' ? this.props.criteriaUtility : this.state.utility,
        // unit: mode == 'new' ? this.props.criteriaUnit[0] : this.state.unit,
        // year: mode == 'new' ? this.props.criteriaYear : this.state.year,
        // month: mode == 'new' ? this.props.criteriaMonth : this.state.month,
        utility: this.state.utility,
        unit: this.state.unit,
        year: this.state.year,
        month: this.state.month,

        pFuel: this.state.pFuel,
        pBurned: this.state.pBurned,
        pAvgHeat: this.state.pAvgHeat,
        pAsh: this.state.pAsh,
        pMoist: this.state.pMoist,
        pSulfur: this.state.pSulfur,
        sFuel: this.state.sFuel,
        sBurned: this.state.sBurned,
        sAvgHeat: this.state.sAvgHeat,
        sAsh: this.state.sAsh,
        sMoist: this.state.sMoist,
        sSulfur: this.state.sSulfur,
        tFuel: this.state.tFuel,
        tBurned: this.state.tBurned,
        tAvgHeat: this.state.tAvgHeat,
        tAsh: this.state.tAsh,
        tMoist: this.state.tMoist,
        tSulfur: this.state.tSulfur,
        qFuel: this.state.qFuel,
        qBurned: this.state.qBurned,
        qAvgHeat: this.state.qAvgHeat,
        qAsh: this.state.qAsh,
        qMoist: this.state.qMoist,
        qSulfur: this.state.qSulfur,
        loiPercent: this.state.loiPercent,
        notes: this.state.notes,
      },
    ]

    if (mode === 'D')
      deleteCard99(
        targetInfo,
        card99Extend
      )(data).fork(
        e => this.props.setError(e, this.props.setShowEditDialog),
        data => {
          if (data.length > 0) {
            this.props.setDataErrors(data)
            // this.setState({ loading: false })
            this.props.setLoading(false)
          } else {
            message.info('Data deleted successfully.')
            this.props.setDataErrors(null)
            this.props.setShowEditDialog(false)
            // this.setState({ loading: false })
            this.props.setLoading(false)
            this.props.retrieveData({})
          }
        }
      )
    else
      postCard99(
        targetInfo,
        card99Extend
      )(data).fork(
        e => this.props.setError(e),
        datar => {
          this.props.setLoading(false)
          if (datar.length > 0) {
            // this.setState({
            //   loading: false,
            //   errors: data,
            //   onlyWarning,
            //   errorPrompt: true,
            //   action: 'save',
            // })
            this.props.setDataErrors(datar)
            // this.props.setShowEditDialog(false)
          } else {
            // this.props.setPromptMsg('Data saved Successfully.', false)
            message.success('Data saved Successfully.')
            // this.setState({ loading: false })
            this.props.setLoading(false)
            this.props.setDataErrors(null)
            this.props.setShowEditDialog(false)
            this.props.retrieveData({})
          }
        }
      )
  }

  handleChange = (e, dataModified = true) => {
    this.setState({
      [e.target.name]: e.target.value,
      dataModified,
    })
  }

  setInsertData = props => {
    this.setState({ loadData: props, dataModified: false })
    this.setState(props)
  }

  clearData = _ => {
    const data = this.props.headers
      .filter(h => !h.isKey && !h.isRequired)
      .map(h => ({ [h.ident]: null }))
      .reduce((a, b) => ({ ...a, ...b }))
    this.setState(data)
  }

  clearModificationData = _ => {
    this.clearData()
    this.setState({ ...(this.state.loadData || {}), dataModified: false })
  }

  render() {
    const {
      mode = 'N',
      setMode,
      utilityNameMap,
      unitNameMap,

      // criteriaMonth,
      // criteriaYear,
      // criteriaUtility,
      // criteriaUnit,
      fuelCodeMap,
      fuelBurnedMap,
      avgHeatMap,
      card99Extend,
      showEditDialog,
      setShowEditDialog,
      utilityUnitMap,
      targetInfo,
      headers,
    } = this.props

    const { isAdmin, lock = 'U' } = this.state

    const renderComponent = [
      {
        mainLabel: 'Primary Fuel',
        label: 'Fuel',
        comp: 'selection',
        type: 'string',
        name: 'pFuel',
        value: this.state.pFuel,
        options: [noneFuelCodeOption, ...fuelCodeOption(fuelCodeMap)],
      },
      {
        label: `Fuel Burned  ${
          fuelBurnedMap[this.state.pFuel]
            ? `(${fuelBurnedMap[this.state.pFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'pBurned',
        value: this.state.pBurned,
      },
      {
        label: `Avg Heat  ${
          avgHeatMap[this.state.pFuel]
            ? `(${avgHeatMap[this.state.pFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'pAvgHeat',
        value: this.state.pAvgHeat,
      },
      {
        label: 'Ash Content %',
        comp: 'input',
        type: 'number',
        name: 'pAsh',
        value: this.state.pAsh,
        max: 99.9,
      },
      {
        label: 'Moisture Content %',
        comp: 'input',
        type: 'number',
        name: 'pMoist',
        value: this.state.pMoist,
        max: 99.9,
      },
      {
        label: 'Sulfur Content %',
        comp: 'input',
        type: 'number',
        name: 'pSulfur',
        value: this.state.pSulfur,
        max: 9.9,
      },
      {
        mainLabel: 'Secondary Fuel',
        label: 'Fuel',
        comp: 'selection',
        type: 'string',
        name: 'sFuel',
        value: this.state.sFuel,
        options: [noneFuelCodeOption, ...fuelCodeOption(fuelCodeMap)],
      },
      {
        label: `Fuel Burned  ${
          fuelBurnedMap[this.state.sFuel]
            ? `(${fuelBurnedMap[this.state.sFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'sBurned',
        value: this.state.sBurned,
      },
      {
        label: `Avg Heat  ${
          avgHeatMap[this.state.sFuel]
            ? `(${avgHeatMap[this.state.sFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'sAvgHeat',
        value: this.state.sAvgHeat,
      },
      {
        label: 'Ash Content %',
        comp: 'input',
        type: 'number',
        name: 'sAsh',
        value: this.state.sAsh,
        max: 99.9,
      },
      {
        label: 'Moisture Content %',
        comp: 'input',
        type: 'number',
        name: 'sMoist',
        value: this.state.sMoist,
        max: 99.9,
      },
      {
        label: 'Sulfur Content %',
        comp: 'input',
        type: 'number',
        name: 'sSulfur',
        value: this.state.sSulfur,
        max: 9.9,
      },
      {
        mainLabel: 'Tertiary Fuel',
        label: 'Fuel',
        comp: 'selection',
        type: 'string',
        name: 'tFuel',
        value: this.state.tFuel,
        options: [noneFuelCodeOption, ...fuelCodeOption(fuelCodeMap)],
      },
      {
        label: `Fuel Burned  ${
          fuelBurnedMap[this.state.tFuel]
            ? `(${fuelBurnedMap[this.state.tFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'tBurned',
        value: this.state.tBurned,
      },
      {
        label: `Avg Heat  ${
          avgHeatMap[this.state.tFuel]
            ? `(${avgHeatMap[this.state.tFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'tAvgHeat',
        value: this.state.tAvgHeat,
      },
      {
        label: 'Ash Content %',
        comp: 'input',
        type: 'number',
        name: 'tAsh',
        value: this.state.tAsh,
        max: 99.9,
      },
      {
        label: 'Moisture Content %',
        comp: 'input',
        type: 'number',
        name: 'tMoist',
        value: this.state.tMoist,
        max: 99.9,
      },
      {
        label: 'Sulfur Content %',
        comp: 'input',
        type: 'number',
        name: 'tSulfur',
        value: this.state.tSulfur,
        max: 9.9,
      },
      {
        mainLabel: 'Quaternary Fuel',
        label: 'Fuel',
        comp: 'selection',
        type: 'string',
        name: 'qFuel',
        value: this.state.qFuel,
        options: [noneFuelCodeOption, ...fuelCodeOption(fuelCodeMap)],
      },
      {
        label: `Fuel Burned  ${
          fuelBurnedMap[this.state.qFuel]
            ? `(${fuelBurnedMap[this.state.qFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'qBurned',
        value: this.state.qBurned,
      },
      {
        label: `Avg Heat  ${
          avgHeatMap[this.state.qFuel]
            ? `(${avgHeatMap[this.state.qFuel]})`
            : ''
        }`,
        comp: 'input',
        type: 'number',
        name: 'qAvgHeat',
        value: this.state.qAvgHeat,
      },
      {
        label: 'Ash Content %',
        comp: 'input',
        type: 'number',
        name: 'qAsh',
        value: this.state.qAsh,
        max: 99.9,
      },
      {
        label: 'Moisture Content %',
        comp: 'input',
        type: 'number',
        name: 'qMoist',
        value: this.state.qMoist,
        max: 99.9,
      },
      {
        label: 'Sulfur Content %',
        comp: 'input',
        type: 'number',
        name: 'qSulfur',
        value: this.state.qSulfur,
        max: 9.9,
      },
    ]

    const renderComponents = columns => {
      let renderFuelComponent = []
      const renderFuelComponentArray = []
      columns.map((g, idx) => {
        if (idx !== 0 && idx % 6 === 0) {
          renderFuelComponentArray.push(renderFuelComponent)
          renderFuelComponent = []
        }
        renderFuelComponent.push(g)
      })
      renderFuelComponentArray.push(renderFuelComponent)
      renderFuelComponent = []
      return renderFuelComponentArray
    }

    const renderComponentFilter = renderComponents(renderComponent)
    const disableCompo =
      mode === 'V' || mode === 'D'
        ? true
        : isAdmin && (mode === 'E' || mode === 'N' || mode === 'D')
        ? false
        : !isAdmin &&
          lock === 'L' &&
          (mode === 'E' || mode === 'N' || mode === 'D')
        ? true
        : false
    const disaableButton =
      mode === 'V'
        ? false
        : isAdmin && (mode === 'N' || mode === 'E' || mode === 'D')
        ? false
        : !isAdmin &&
          lock === 'L' &&
          (mode === 'E' || mode === 'N' || mode === 'D')
        ? true
        : false

    return [
      <Modal
        destroyOnClose
        bodyStyle={{ padding: '10px 20px' }}
        onCancel={() => setShowEditDialog(false)}
        title={
          <InsertHeader
            disableComp={disableCompo}
            isAdmin={isAdmin}
            setShowEditDialog={setShowEditDialog}
            utilityUnitMap={utilityUnitMap}
            utilityNameMap={utilityNameMap}
            unitNameMap={unitNameMap}
            handleChange={this.handleChange}
            state={this.state}
            apiTargetInfo={targetInfo}
            setInsertData={this.setInsertData}
            card99Extend={card99Extend}
            headers={headers}
            mode={mode}
            setMode={setMode}
            setLoading={this.props.setLoading}
            setError={this.props.setError}
            spinning={this.props.spinning}
            dataModified={this.state.dataModified}
            clearData={this.clearData}
          />
        }
        visible={showEditDialog}
        key="card99editprompt"
        style={{ top: 20, zIndex: 500 }}
        width={1000}
        footer={
          <div>
            <Button
              type="primary"
              onClick={this.save}
              loading={this.props.spinning || false}
              disabled={!this.state.dataModified && disaableButton}
            >
              {mode === 'N'
                ? 'Insert'
                : mode === 'D'
                ? 'Delete'
                : mode === 'E'
                ? 'Save'
                : 'OK'}
            </Button>
            {(mode === 'N' || mode === 'E') && (
              <Button
                onClick={this.clearModificationData}
                disabled={!this.state.dataModified}
              >
                Clear Modification
              </Button>
            )}

            {mode !== 'V' && (
              <Button
                onClick={() => {
                  setShowEditDialog(false)
                }}
                loading={this.props.spinning || false}
              >
                Cancel
              </Button>
            )}
          </div>
        }
        maskClosable={false}
      >
        <Spin spinning={this.props.spinning || false}>
          <SupDiv>
            {renderComponentFilter.map((l, i) => (
              <div style={{ marginLeft: i !== 0 ? '40px' : undefined }}>
                <b>{l[0].mainLabel}</b>
                <ContentDiv>
                  {l.map(c => (
                    <SubDiv style={{ marginTop: '5px' }}>
                      <div style={{ fontWeight: 500 }}>{c.label}</div>
                      {c.comp ? (
                        c.comp === 'input' ? (
                          c.type === 'number' ? (
                            <InputNumber
                              disabled={disableCompo}
                              style={{ width: 'inherit' }}
                              key={c.name}
                              type={c.type}
                              value={c.value}
                              placeholder={c.label}
                              name={c.name}
                              min={0}
                              max={c.max}
                              onChange={value => {
                                if (c.max && value > c.max) {
                                  this.handleChange({
                                    target: { name: c.name, value: c.max },
                                  })
                                } else
                                  this.handleChange({
                                    target: { name: c.name, value },
                                  })
                              }}
                            />
                          ) : (
                            <Input
                              disabled={disableCompo}
                              size="small"
                              key={c.name}
                              type={c.type}
                              value={c.value || ''}
                              placeholder={c.label}
                              name={c.name}
                              onChange={this.handleChange}
                            />
                          )
                        ) : (
                          <Select
                            disabled={disableCompo}
                            id={c.name}
                            key={c.name}
                            value={c.value || ''}
                            placeholder={c.label}
                            name={c.name}
                            onChange={value =>
                              this.handleChange({
                                target: { name: c.name, value },
                              })
                            }
                            selection
                            options={c.options}
                          >
                            {c.options.map(u => (
                              <Select.Option value={u.value}>
                                {u.text}
                              </Select.Option>
                            ))}
                          </Select>
                        )
                      ) : (
                        undefined
                      )}
                    </SubDiv>
                  ))}
                </ContentDiv>
              </div>
            ))}
          </SupDiv>
          {card99Extend && (
            <>
              <div style={{ marginTop: '5px' }}>
                <b>{'LOI % '}</b>
                <Input
                  disabled={disableCompo}
                  size="small"
                  key="loiPercent"
                  type="number"
                  value={this.state.loiPercent || ''}
                  // placeholder="Loi Percent"
                  name="loiPercent"
                  onChange={this.handleChange}
                />
              </div>
              <div style={{ marginTop: '5px' }}>
                <b>{'Notes: '}</b>
                <TextArea
                  disabled={disableCompo}
                  key="notes"
                  // placeholder="Notes"
                  name="notes"
                  value={this.state.notes || ''}
                  onChange={this.handleChange}
                  autoHeight={false}
                  rows={2}
                />
              </div>
            </>
          )}
        </Spin>
      </Modal>,
    ]
  }
}

export default Card99EditPrompt
